export default [
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/marketing/notifications/pages/Notifications.vue'),
    meta: {
      allowedCountries: ['LY'],
      resource: 'notifications',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Notifications',
      breadcrumb: [
        {
          text: 'Notifications',
          active: true,
        },
      ],
    },
  },
  {
    path: '/create-notification',
    name: 'create-notification',
    component: () => import('@/views/marketing/notifications/pages/CreateNotification.vue'),
    meta: {
      allowedCountries: ['LY'],
      resource: 'notifications',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Notifications',
      breadcrumb: [
        {
          text: 'Notifications',
          to: '/notifications',
        },
      ],
    },
  },
  {
    path: '/add-device',
    name: 'add-device',
    component: () => import('@/views/marketing/notifications/pages/AddDevice.vue'),
    meta: {
      allowedCountries: ['LY'],
      resource: 'notifications',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Notifications',
      breadcrumb: [
        {
          text: 'Notifications',
          to: '/notifications',
        },
      ],
    },
  },
]
